import React, { useState } from "react";
import {
  IonContent,
  IonPage,
  IonToolbar,
  IonTitle,
  IonButtons,
} from "@ionic/react";
import Logo from "../../components/Logo";
import Visits from "./components/Visits";
import Header from "./components/Header";
import { useIntl } from "react-intl";

const Home = () => {
  const intl = useIntl();
  const [isFetching, setIsFetching] = useState(false);
  const setFetching = (val) => {
    setIsFetching(val);
  };
  return (
    <IonPage>
      <IonToolbar color="primary">
        <IonButtons slot="primary">
          <Logo />
        </IonButtons>
        <IonTitle>
          {intl.formatMessage({
            id: "app.mobile.titles.home",
          })}
        </IonTitle>
      </IonToolbar>
      <div style={{ display: "flex", height: "100%", flexDirection: "column" }}>
        <Header loading={isFetching} />
        <IonContent>
          <Visits setFetching={setFetching} />
        </IonContent>
      </div>
    </IonPage>
  );
};

export default Home;
